export default __webpack_public_path__ + "maps-examples-offline-storage-1200-f532a17d819152e057e4ac9280bf062b.webp";